import { useTheme } from '@mui/material';
import L from 'leaflet';
import React, { useEffect } from 'react';
import { renderToString } from 'react-dom/server';
import { useMap } from 'react-leaflet';

interface Props {
  href: string;
  image: React.ReactNode;
}

declare module 'leaflet' {
  // eslint-disable-next-line @typescript-eslint/no-namespace
  namespace Control {
    export class Watermark extends L.Control {
      constructor(options?: L.ControlOptions);
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-namespace
  namespace control {
    export function watermark(options?: L.ControlOptions): Control.Watermark;
  }
}

const Watermark: React.FC<Props> = ({ href, image }) => {
  const map = useMap();
  const { mode } = useTheme().palette;

  useEffect(() => {
    if (!map) {
      return;
    }

    L.Control.Watermark = L.Control.extend<{ onAdd: () => HTMLAnchorElement }>({
      onAdd: function () {
        const link = L.DomUtil.create('a', 'watermark');
        link.href = href;
        link.target = '_blank';
        link.innerHTML = renderToString(React.cloneElement(image as unknown as React.ReactElement, { mode }));

        return link;
      },
    });

    L.control.watermark = function (opts) {
      return new L.Control.Watermark(opts);
    };

    const control = L.control.watermark({ position: 'bottomleft' }).addTo(map);

    return () => {
      map.removeControl(control);
    };
  }, [href, image, map, mode]);

  return null;
};

export default Watermark;
